import React, { Fragment, } from 'react'
import './style.css'
export default function Notice(props) {
    const { data } = props;
    return (
        <div className='GuideCarousel_Notice'>
            <div className='GuideCarousel_NoticeTitle'>
                <div className='GuideCarousel_NoticeTitleText'>{data.title}</div>
                <div className='GuideCarousel_NoticeTitleTime'>{data.time}</div>
            </div>
            <div className='GuideCarousel_NoticeContent'>
                <div className='GuideCarousel_NoticeContentText'>{data.content}</div>
            </div>
        </div>
    )
}